import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagMZ = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "m13.512 34.783-6.19 7.894A24.918 24.918 0 0 0 25 50c10.335 0 19.204-6.272 23.01-15.217H13.513Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#496E2D",
  d: "M48.049 15.308C44.263 6.315 35.369 0 24.999 0A24.918 24.918 0 0 0 7.322 7.323l6.261 7.985H48.05Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#000",
  d: "M5.434 18.387v13.134h43.703C49.699 29.442 50 27.256 50 25c0-2.29-.309-4.506-.885-6.613H5.434Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#A2001D",
  d: "M7.323 7.321c-9.763 9.763-9.763 25.592 0 35.355L25.001 25 7.323 7.32Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "m10.119 18.479 1.619 4.982h5.238l-4.238 3.079 1.619 4.982-4.238-3.08-4.238 3.08L7.5 26.54l-4.238-3.08H8.5l1.619-4.982Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M5.38 25h9.475v4.348H5.38V25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#000",
  d: "m16.651 20.016-1.537-1.537-4.995 4.994-4.995-4.994-1.537 1.537 5 4.99-5 5 1.537 1.516 4.995-4.986 4.995 4.986 1.537-1.516-5-5 5-4.99Z"
}));
FlagMZ.displayName = 'FlagMZ';
export default withFlagWrapper(FlagMZ);
//# sourceMappingURL=index.js.map